(function () {
  function initLead(root) {
    if (!root || root.dataset.wpeInitialized === 'true') return;
    var slider = root.querySelector('[data-wpe-slider]');
    if (!slider) return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-wpe-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-wpe-dot]'));
    var prev = slider.querySelector('[data-wpe-prev]');
    var next = slider.querySelector('[data-wpe-next]');
    if (!slides.length) return;

    root.dataset.wpeInitialized = 'true';
    var index = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true' && slides.length > 1;
    var interval = parseInt(root.dataset.interval || '6000', 10);

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (autoplay) timer = window.setInterval(function () { show(index + 1); }, interval);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.wpeDot || '0', 10));
        start();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
  }

  function initProductSlider(root) {
    if (!root || root.dataset.wpeProductInitialized === 'true') return;
    var scroller = root.querySelector('[data-wpe-product-scroller]');
    var prev = root.querySelector('[data-wpe-product-prev]');
    var next = root.querySelector('[data-wpe-product-next]');
    if (!scroller || !prev || !next) return;

    root.dataset.wpeProductInitialized = 'true';

    function cardStep() {
      var card = scroller.querySelector('.wpe-product-card');
      if (!card) return Math.max(280, scroller.clientWidth * 0.8);
      var styles = window.getComputedStyle(scroller);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max;
      var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 4;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
    }

    prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scroller.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Shopify does not support a native published-descending collection sort.
    // Read the entire published collection (50 products per request), keeping
    // only eligible products and the original product-card markup. Sort by
    // the real publication timestamp once all collection pages are checked.
    var collectionHandle = root.dataset.wpeNewestCollection;
    if (collectionHandle && window.fetch) {
      var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var feedUrl = new URL(routeRoot + 'collections/' + encodeURIComponent(collectionHandle), window.location.origin);
      feedUrl.searchParams.set('sort_by', 'created-descending');
      feedUrl.searchParams.set('section_id', 'wpe-newest-product-feed');
      var previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewThemeId) feedUrl.searchParams.set('preview_theme_id', previewThemeId);

      var limit = parseInt(root.dataset.wpeNewestLimit, 10) || 12;
      var visitedPages = Object.create(null);
      var eligibleCards = [];

      function readPage(url) {
        if (visitedPages[url]) return Promise.reject(new Error('Repeated feed page'));
        visitedPages[url] = true;
        return fetch(url, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Product feed unavailable');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var feed = doc.querySelector('[data-wpe-newest-feed-results][data-wpe-feed-ready="true"]');
            if (!feed) throw new Error('Unrecognized product feed');

            var items = feed.querySelectorAll('[data-wpe-newest-feed-item]');
            Array.prototype.forEach.call(items, function (item) {
              var published = Number(item.dataset.wpePublished);
              var card = item.querySelector('.wpe-product-card');
              if (!card || !Number.isFinite(published) || published <= 0) return;
              eligibleCards.push({ published: published, card: card });
            });

            // Release all but the best candidates from the current batch;
            // older pages can still contain more recently published products.
            eligibleCards.sort(function (a, b) { return b.published - a.published; });
            eligibleCards.length = Math.min(eligibleCards.length, limit);

            var nextPath = feed.getAttribute('data-wpe-feed-next-url');
            if (!nextPath) return eligibleCards;
            var nextUrl = new URL(nextPath, window.location.origin);
            nextUrl.searchParams.set('section_id', 'wpe-newest-product-feed');
            if (previewThemeId) nextUrl.searchParams.set('preview_theme_id', previewThemeId);
            return readPage(nextUrl.toString());
          });
      }

      readPage(feedUrl.toString())
        .then(function (cards) {
          // All cards come from the existing WPE product-card snippet, so
          // the display and styling are unchanged from the original theme.
          var cardNodes = cards.map(function (entry) { return entry.card; });
          if (root.dataset.wpeNewestShowVendor !== 'true') {
            cardNodes.forEach(function (card) {
              var vendor = card.querySelector('.wpe-product-card__vendor');
              if (vendor) vendor.remove();
            });
          }
          scroller.replaceChildren.apply(scroller, cardNodes);
          scroller.scrollLeft = 0;
          update();
        })
        .catch(function (error) {
          // The first Liquid-rendered cards use the same stock/image filters.
          // On a fetch error retain them rather than insert unchecked items.
          if (window.console && window.console.warn) {
            window.console.warn('WPE product feed: unable to complete published-date sorting', error);
          }
        });
    }
  }


  function initScrollSection(root) {
    if (!root || root.dataset.wpeScrollInitialized === 'true') return;
    var scroller = root.querySelector('[data-wpe-scroll]');
    var prev = root.querySelector('[data-wpe-scroll-prev]');
    var next = root.querySelector('[data-wpe-scroll-next]');
    if (!scroller || !prev || !next) return;

    root.dataset.wpeScrollInitialized = 'true';

    function itemStep() {
      var item = scroller.querySelector('[data-wpe-scroll-item]');
      if (!item) return Math.max(240, scroller.clientWidth * 0.75);
      var styles = window.getComputedStyle(scroller);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      var hasOverflow = scroller.scrollWidth > scroller.clientWidth + 4;
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
    }

    prev.addEventListener('click', function () { scroller.scrollBy({ left: -itemStep(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { scroller.scrollBy({ left: itemStep(), behavior: 'smooth' }); });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wpe-home-lead]').forEach(initLead);
    (scope || document).querySelectorAll('[data-wpe-product-section]').forEach(initProductSlider);
    (scope || document).querySelectorAll('[data-wpe-scroll-section]').forEach(initScrollSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
